import { render, staticRenderFns } from "./SolicitaAtencion.vue?vue&type=template&id=a40d76a2&scoped=true"
import script from "./SolicitaAtencion.vue?vue&type=script&lang=ts"
export * from "./SolicitaAtencion.vue?vue&type=script&lang=ts"
import style0 from "./SolicitaAtencion.vue?vue&type=style&index=0&id=a40d76a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40d76a2",
  null
  
)

export default component.exports